import { CircularProgressWithLabel } from "./upcomingSessionUtils";
import { Translate } from "@/app/application/Translate";
import LaunchIcon from "@mui/icons-material/Launch";
import { IconButton, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

export interface UpcomingSessionRow {
	Id: number;
	Name: string;
	Date: string | Date;
	CourseId?: number;
	DrillId?: number;
}

/**
 * Returns column definitions for the UpcomingSessionsDashboard DataGrid.
 *
 * @param handleNavigate - callback to navigate when an action is clicked
 */
export const getUpcomingSessionsColumns = (
	handleNavigate: (row: UpcomingSessionRow) => void,
): GridColDef<UpcomingSessionRow>[] => [
	{ field: "Name", headerName: "Session Name", flex: 1 },

	{
		field: "Date",
		headerName: "Date",
		flex: 0.5,
		renderCell: (params) => {
			const raw = params.row.Date;
			const d = raw ? dayjs(raw) : null;
			return (
				<Typography variant="caption">
					{d && d.isValid() ? d.format("DD/MM/YY") : "—"}
				</Typography>
			);
		},
	},

	{
		field: "StatusIndicator",
		headerName: "Status",
		flex: 0.7,
		sortable: false,
		filterable: false,
		renderCell: (params) => {
			const sessionDate = dayjs(params.row.Date);
			const today = dayjs();
			const daysAway = sessionDate.diff(today, "day");

			return daysAway < 0 ? (
				<Typography variant="caption" color="error">
					<Translate String="Training.session.overdue">Overdue by</Translate>:{" "}
					{Math.abs(daysAway)} <Translate String="Common.days">days</Translate>
				</Typography>
			) : (
				<CircularProgressWithLabel value={daysAway} />
			);
		},
	},

	{
		field: "Actions",
		headerName: "",
		sortable: false,
		filterable: false,
		flex: 0.2,
		renderCell: (params) => (
			<IconButton onClick={() => handleNavigate(params.row)}>
				<LaunchIcon fontSize="small" />
			</IconButton>
		),
	},
];
